// extracted by mini-css-extract-plugin
export default {"button":"button__S0rFuq","defaultButton":"defaultButton__uT4PhL"};